// @refresh reload
import { mount, StartClient } from '@solidjs/start/client';
import { PersistentClient } from './shared/PersistentClient';
import { isServer } from 'solid-js/web';

export default mount(() => <StartClient />, document.getElementById('app')!);
